import React from 'react'
import BVLogo from '../Images/Branding/BVLogo.png'
import CPLogo from '../Images/Branding/CPLogo.png'
import MCLogo from '../Images/Branding/MCLogo.png'

const partnerships = [
  { id: 1, name: 'Bandera Ventures', logo: BVLogo, unitnum: '+5K' },
  { id: 2, name: 'Cawley Partners', logo: CPLogo, unitnum: '+3K' },
  { id: 3, name: 'Monarch Collective', logo: MCLogo, unitnum: '+6k' },
  { id: 4, name: 'Bandera Ventures', logo: BVLogo, unitnum: '+5K' },
  { id: 5, name: 'Cawley Partners', logo: CPLogo, unitnum: '+3K' },
  { id: 6, name: 'Monarch Collective', logo: MCLogo, unitnum: '+6k' },
  { id: 7, name: 'Bandera Ventures', logo: BVLogo, unitnum: '+5K' },
  { id: 8, name: 'Cawley Partners', logo: CPLogo, unitnum: '+3K' },
  { id: 9, name: 'Monarch Collective', logo: MCLogo, unitnum: '+6k' },
]

const PartnershipScroller = () => {
  return (
    <div className="container partnershipcontainter ">
      <div className="partnership-scroller">
        <h1 className="partnerherosection">
          Our Real Estate Partners Are Looking for Pros Like You
        </h1>
        <div className="scroller-container">
          <div className="scroller-content">
            {partnerships.map((partner) => (
              <div key={partner.id} className="partner-item">
                <img
                  src={partner.logo}
                  // alt={partner.name}
                  className="partner-logo"
                />
                <p>
                  <strong>{partner.name}</strong>
                </p>
                <p>{partner.unitnum} Properties</p>
              </div>
            ))}
            {/* Duplicate the items for continuous scrolling */}
            {partnerships.map((partner) => (
              <div key={`${partner.id}-duplicate`} className="partner-item">
                <img
                  src={partner.logo}
                  // alt={partner.name}
                  className="partner-logo"
                />
                <p>
                  <strong>{partner.name}</strong>
                </p>
                <p>{partner.unitnum} Properties</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PartnershipScroller
